import { Drawer } from '@app/components'
import { AddDiscountDrawerProps } from '@app/types'
import { Discount } from 'collections/discount'
import React from 'react'

export const AddDiscountDrawer: React.FC<AddDiscountDrawerProps> = ({ open, toggleOpen }) => {
  return (
    <>
      <Drawer title="Add Discount" onClose={toggleOpen} open={open}>
        <Discount isForDrawer />
      </Drawer>
    </>
  )
}
